import { AddPeople } from "@organisms";
import AddStoryIcon from "@assets/icons/addStory.svg";
import { Button } from "@atoms";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { StoryFormProvider } from "../../../contexts/StoryFormContext";

function AddStoryBtn() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        fullWidth
        icon={<img src={AddStoryIcon} alt="add" />}
        iconPosition="right"
        style={{ justifyContent: "space-between", height: "43px" }}
        onClick={() => setOpen(true)}
      >
        {t("addStory")}
      </Button>
      {open && (
        <StoryFormProvider>
          <AddPeople open={open} setOpen={setOpen} />
        </StoryFormProvider>
      )}
    </>
  );
}

export default AddStoryBtn;
